'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMinimalistPortal = require('react-minimalist-portal');

var _reactMinimalistPortal2 = _interopRequireDefault(_reactMinimalistPortal);

var _CSSTransition = require('react-transition-group/CSSTransition');

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _noScroll = require('no-scroll');

var _noScroll2 = _interopRequireDefault(_noScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.onClickOverlay = function (e) {
      var _this$props = _this.props,
          classes = _this$props.classes,
          closeOnOverlayClick = _this$props.closeOnOverlayClick;

      if (!closeOnOverlayClick || typeof e.target.className !== 'string') {
        return;
      }
      var className = e.target.className.split(' ');
      if (className.indexOf(classes.overlay) !== -1) {
        e.stopPropagation();
        _this.props.onClose();
      }
    };

    _this.onClickCloseIcon = function (e) {
      e.stopPropagation();
      _this.props.onClose();
    };

    _this.handleKeydown = function (e) {
      if (e.keyCode === 27) {
        _this.props.onClose();
      }
    };

    _this.handleExited = function () {
      _this.setState({ showPortal: false });
      _this.unblockScroll();
    };

    _this.unblockScroll = function () {
      var openedModals = document.getElementsByClassName(_this.props.classes.modal);
      if (openedModals.length === 1) {
        _noScroll2.default.off();
      }
    };

    _this.state = {
      showPortal: props.open
    };
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      // Block scroll when initial prop is open
      if (this.props.open) {
        this.blockScroll();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!this.props.open && nextProps.open) {
        this.setState({
          showPortal: true
        }, function () {
          _this2.blockScroll();
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      this.unblockScroll();
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'blockScroll',


    // eslint-disable-next-line class-methods-use-this
    value: function blockScroll() {
      _noScroll2.default.on();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          little = _props.little,
          classes = _props.classes,
          classNames = _props.classNames,
          styles = _props.styles,
          showCloseIcon = _props.showCloseIcon,
          closeIconSize = _props.closeIconSize,
          closeIconSvgPath = _props.closeIconSvgPath,
          animationDuration = _props.animationDuration;
      var showPortal = this.state.showPortal;

      if (!showPortal) return null;
      return _react2.default.createElement(
        _reactMinimalistPortal2.default,
        null,
        _react2.default.createElement(
          _CSSTransition2.default,
          {
            'in': open,
            appear: true,
            classNames: {
              appear: classNames.transitionEnter || classes.transitionEnter,
              appearActive: classNames.transitionEnterActive || classes.transitionEnterActive,
              enter: classNames.transitionEnter || classes.transitionEnter,
              enterActive: classNames.transitionEnterActive || classes.transitionEnterActive,
              exit: classNames.transitionExit || classes.transitionExit,
              exitActive: classNames.transitionExitActive || classes.transitionExitActive
            },
            timeout: animationDuration,
            onExited: this.handleExited
          },
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)(classes.overlay, little ? classes.overlayLittle : null, classNames.overlay),
              onMouseDown: this.onClickOverlay,
              style: styles.overlay
            },
            _react2.default.createElement(
              'div',
              {
                className: (0, _classnames2.default)(classes.modal, classNames.modal),
                style: styles.modal
              },
              showCloseIcon ? _react2.default.createElement(
                'svg',
                {
                  className: (0, _classnames2.default)(classes.closeIcon, classNames.closeIcon),
                  style: styles.closeIcon,
                  onClick: this.onClickCloseIcon,
                  xmlns: 'http://www.w3.org/2000/svg',
                  width: closeIconSize,
                  height: closeIconSize,
                  viewBox: '0 0 36 36'
                },
                closeIconSvgPath
              ) : null,
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  closeOnEsc: _propTypes2.default.bool,
  closeOnOverlayClick: _propTypes2.default.bool,
  onClose: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool.isRequired,
  classNames: _propTypes2.default.object,
  styles: _propTypes2.default.object,
  children: _propTypes2.default.node,
  classes: _propTypes2.default.object.isRequired,
  little: _propTypes2.default.bool,
  showCloseIcon: _propTypes2.default.bool,
  closeIconSize: _propTypes2.default.number,
  closeIconSvgPath: _propTypes2.default.node,
  animationDuration: _propTypes2.default.number
};

Modal.defaultProps = {
  closeOnEsc: true,
  closeOnOverlayClick: true,
  showCloseIcon: true,
  closeIconSize: 28,
  closeIconSvgPath: _react2.default.createElement('path', { d: 'M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z' }),
  classNames: {},
  styles: {},
  children: null,
  little: false,
  animationDuration: 500
};

exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./~/react-responsive-modal/lib/modal.js
// module id = 293
// module chunks = 0